import { makeStyles } from "@material-ui/core/styles";
import { themeCommon } from "../../theme";

const useStyles = makeStyles((theme) => ({
  rootLink: {
    display: "block !important",
    paddingTop: '2px',
    paddingBottom: '2px',
  },
  rootItemGroup: {
    fontSize: "10px",
    color: themeCommon.lightBlue,
  },
  rootItem: {
    margin: "0px 10px 10px",
    border: `0.5px solid ${themeCommon.borderGray}`,
    borderRadius: "5px",
    textOverflow: "ellipsis",
    background: 'white',
    "&:hover": {
      background: "0 !important",
      background: themeCommon.hovercolor,
    },
    "&:focus": {
      background: "0 !important",
      background: themeCommon.hovercolor,
    },
  },
  rootItemRead: {
    background: `${themeCommon.bg_btn_lightBlue} !important`,
  },
  rootItemTitle: {
    fontSize: themeCommon.fontSize14px,
    width: '100%', 
    display: '-webkit-box',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      fontSize: themeCommon.fontSize12px,
    },
  },
  textBold: {
    fontWeight: 700,
  },
  textGreen: {
    color: '#4DD091'
  }
}), {
  name: 'NofiticationPopoverHolderHeadContainer',
  index: 1,
})

export default useStyles;
